(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentSearch', [ContentSearchDirective])
		.controller('ContentSearchController',
		[
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbStatusDataStore',
			'smbUsersDataStore',
			'smbIndexTypesDataStore',
			'smbContentSearchDataStore',
			'smbContentTypeGroupConfigDataStore',
			'smbContentTypeConfigDataStore',
			'smbIconTypes',
			ContentSearchController
		]);

	var templateUrl = require('./contentSearch.template');
	function ContentSearchDirective() {
		return {
			restrict: 'E',
			controller: ContentSearchController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				groupId: '@',
				typeId: '@'
			},
			scope: {}
		};
	}

	function ContentSearchController($state, gettextCatalog, pxProgressService, smbToolbarService, smbStatusDataStore, smbUsersDataStore, smbIndexTypesDataStore,
										smbContentSearchDataStore, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes) {

		smbToolbarService.set(gettextCatalog.getString('Search Document Type'), 'search.contentTypeGroups.contentTypes');

		var vm = this;
		var ARCHIVAL_STATUS = 'Archival Status';
		var TODO_STATUS = 'ToDo Status';

		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];

		vm.docDateStart = new Date();
		vm.docDateEnd = new Date();

		vm.search = search;

		vm.contentTypeDS = smbContentTypeConfigDataStore;
		vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
		vm.indexTypesDS = smbIndexTypesDataStore;
		vm.statusDS = smbStatusDataStore;
		vm.usersDS = smbUsersDataStore;
		vm.filename = null;

		vm.indextypes = [];
		vm.contentStatuses = [];
		vm.todoStatuses = [];
		vm.status = null;
		vm.selectedUser = null;
		vm.isContentStatusSelected = false;
		vm.onStatusChange = onStatusChange;

		vm.indexFileChanged = indexFileChanged;

		function indexFileChanged(fileInput) {
			if (fileInput.files.length === 0) {
				return;
			}
			vm.filename = fileInput.files[0].name;
		}

		vm.contentTypeGroupDS.getContentTypeGroup(vm.groupId)
		.then(function () {
			vm.contentTypeDS.getContentType(vm.groupId, vm.typeId);
		})
		.then(function () {
			vm.indexTypesDS.getIndexTypes(vm.typeId).then(function () {
				vm.indextypes = vm.indexTypesDS.indexTypes.map(function(it) {
					return angular.extend({}, it, {defaultValue: undefined});
				});
			});
		})
		.then(function() {
			return vm.statusDS.loadStatuses(vm.typeId);
		})
		.then(function() {
			vm.contentStatuses = [];
			if (vm.statusDS.contentStatus[0]) {
				vm.contentStatuses = vm.statusDS.contentStatus[0].Constraints.DataSetValues.map(function(s) {
					return {TagTypeId: vm.statusDS.contentStatus[0].TagTypeId, indexValue: s, type: ARCHIVAL_STATUS};
				});
			}
			vm.todoStatuses = [];
			if (vm.statusDS.todoStatus[0]) {
				vm.todoStatuses = vm.statusDS.todoStatus[0].Constraints.DataSetValues.map(function(s) {
					return {TagTypeId: vm.statusDS.todoStatus[0].TagTypeId, indexValue: s, type: TODO_STATUS};
				});
			}
		})
		.then(function() {
			return vm.usersDS.getUsers();
		});

		function onStatusChange() {
			if (vm.status) {
				var Status = JSON.parse(vm.status);
				if (Status.type === ARCHIVAL_STATUS) {
					vm.isContentStatusSelected = true;
				}
				else {
					vm.isContentStatusSelected = false;
				}
			}
			else {
				vm.isContentStatusSelected = false;
				vm.status = undefined;
			}
		}

		function search() {
			if (vm.status) {
				vm.status = JSON.parse(vm.status);
				vm.indextypes.push({TagTypeId: vm.status.TagTypeId, indexValue: vm.status.indexValue});
			}
			if (vm.selectedUser && !vm.isContentStatusSelected) {
				vm.selectedUser = JSON.parse(vm.selectedUser);
				vm.indextypes.push({TagTypeId: vm.indexTypesDS.assignedUserId, indexValue: vm.selectedUser.UserId});
			}
			smbContentSearchDataStore.setTagValues(vm.indextypes);
			$state.go('search.contentTypeGroups.contentTypes.search.results',{ groupId: vm.groupId, typeId: vm.typeId });
		}
	}
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/contentSearch/contentSearch.js
// module id = 64
// module chunks = 1